import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { useAIStudio } from 'src/components/global-ai-studio/AIStudioContext';
import { AIStudioTriggerButton } from 'src/components/global-ai-studio/AIStudioTriggerButton';

interface SummaryCardProps {
  conversationId: string;
  summary: string;
}

export const SummaryCard = ({ conversationId, summary }: SummaryCardProps) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { open: openAIStudio } = useAIStudio();

  return (
    <Box display='flex' flexDirection='column' gap='10px'>
      <Typography variant='font14Bold'>{t('summaryCard.summary')}</Typography>
      <SummaryContainer>
        <Typography variant='font14'>{summary}</Typography>
        <AIStudioTriggerButton
          iconPosition='start'
          label={t('summaryCard.openInAiStudio')}
          onClick={() =>
            openAIStudio({
              entryMethod: 'conversation_drawer',
              prompt: t('summaryCard.summarizePrompt', {
                conversationId,
              }),
            })
          }
        />
      </SummaryContainer>
    </Box>
  );
};

const SummaryContainer = styled(Box)`
  background: linear-gradient(
    90deg,
    rgba(255, 179, 147, 0.15) 0%,
    rgba(188, 206, 229, 0.15) 39.95%,
    rgba(171, 213, 250, 0.15) 50%,
    rgba(18, 166, 180, 0.15) 100%
  );
  border: 1px solid ${({ theme }) => theme.palette.colors.slate[200]};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;
